import { moment } from "@msuite/utils/date";
import { cva, type VariantProps } from "class-variance-authority";
import { Tag, TagGroup, TagList } from "react-aria-components";
import { cn } from "../utils";

const WEEKDAYS = Array.from({ length: 7 }).map((_, index) => index);

/** Props Interface */
interface WeekdaysProps extends VariantProps<typeof weekdayClasses> {
	selectedDays: number[];
	onSelectionChange?: (selectedKeys: number[]) => void;
	disabledDays?: number[];
	isReadonly?: boolean;
}

export function Weekdays({
	selectedDays,
	disabledDays,
	onSelectionChange,
	isReadonly = true,
	size,
}: WeekdaysProps) {
	/** Classes */
	const classes = weekdayClasses({ size });

	/** Render */
	return (
		<TagGroup
			selectionMode="multiple"
			selectedKeys={selectedDays}
			onSelectionChange={(keys) => {
				const newSelection = Array.from(keys) as number[];
				onSelectionChange?.(newSelection);
			}}
		>
			<TagList className="h-stack w-full">
				{WEEKDAYS.map((offset) => (
					<Tag
						key={offset}
						id={offset}
						isDisabled={disabledDays?.includes(offset)}
						className={cn(
							"cursor-default",
							"flex-1 card-bg border-[0.5px] border-color rounded-base flex-center text-sm",
							!isReadonly && "data-focused:input-focused",
							"data-selected:bg-accent-100 data-selected:**:text-accent-800! data-selected:border-accent-500",
							"data-selected:dark:bg-accent-950/40 data-selected:dark:**:text-accent-100! data-selected:dark:border-accent-600",
							classes,
						)}
					>
						<p>{moment().weekday(offset).format("dd")}</p>
					</Tag>
				))}
			</TagList>
		</TagGroup>
	);
}

const weekdayClasses = cva([], {
	variants: {
		size: {
			xs: "",
			base: "py-3",
		},
	},
	defaultVariants: {
		size: "base",
	},
});
